import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import { createUserRegistryQuery, User, UserRegistryFilters } from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';

export type UserRegistryModel = RegistryModel<User, UserRegistryFilters, JsonApiRequestError>;

export type CreateUserRegistryModelParams = {
	$accountId?: Store<number | null>;
} & RegistryCallbacks;

export const createUserRegistryModel = ({
	$accountId,
	...params
}: CreateUserRegistryModelParams): UserRegistryModel => {
	const query = createUserRegistryQuery($accountId);

	return createRegistryModel({
		query,
		filters: {
			name: '',
			roles: [],
			accountIds: [],
		},
		sortField: 'name',
		...params,
	});
};
